import { useQuery } from "@tanstack/react-query";
import { motion } from "framer-motion";
import { TrendingUp, Receipt, IndianRupee, Wallet, CalendarDays, CalendarRange, Landmark, Coins } from "lucide-react";
import api, { fmt } from "@/lib/api";

const CARDS = [
  { key: "today_sales", label: "Today's Sales", icon: TrendingUp, color: "text-emerald-500" },
  { key: "today_expenses", label: "Today's Expenses", icon: Receipt, color: "text-red-400" },
  { key: "today_profit", label: "Today's Profit", icon: IndianRupee, color: "text-amber-500", signed: true },
  { key: "month_sales", label: "This Month Sales", icon: CalendarDays, color: "text-sky-500" },
  { key: "month_expenses", label: "This Month Expenses", icon: Wallet, color: "text-rose-500" },
  { key: "month_profit", label: "This Month Profit", icon: Coins, color: "text-green-500", signed: true },
  { key: "year_profit", label: "This Year Profit", icon: CalendarRange, color: "text-indigo-500", signed: true },
  { key: "cash_balance", label: "Current Cash Balance", icon: Landmark, color: "text-amber-400", signed: true },
];

export default function BADashboard() {
  const { data, isLoading } = useQuery({
    queryKey: ["ba-dashboard"],
    queryFn: async () => (await api.get("/ba/dashboard")).data,
    staleTime: 15000,
  });

  if (isLoading || !data) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {Array.from({ length: 8 }).map((_, i) => <div key={i} className="h-28 rounded-xl bg-muted animate-pulse" />)}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-testid="ba-dashboard">
      {CARDS.map(({ key, label, icon: Icon, color, signed }, i) => (
        <motion.div
          key={key}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: i * 0.04, duration: 0.3 }}
          data-testid={`ba-card-${key.replace(/_/g, "-")}`}
          className="rounded-xl border bg-card p-5"
        >
          <div className="flex items-start justify-between">
            <p className={`font-heading text-xl lg:text-2xl font-semibold tracking-tight ${signed && data[key] < 0 ? "text-red-500" : ""}`}>
              {fmt(data[key])}
            </p>
            <Icon className={`h-5 w-5 ${color} opacity-80`} />
          </div>
          <p className="text-xs lg:text-sm text-muted-foreground mt-2">{label}</p>
        </motion.div>
      ))}
    </div>
  );
}
